import { useState } from 'react';
import { Button } from './ui/button';
import { Trash2, X } from 'lucide-react';

const ConfirmDelete = ({ onConfirm, children, message }) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = (e) => {
    e?.stopPropagation();
    setOpen(false);
    onConfirm();
  };

  if (open) {
    return (
      <div className="flex items-center gap-1.5 animate-in fade-in duration-150" data-testid="confirm-delete" onClick={e => e.stopPropagation()}>
        <span className="text-[10px] text-red-400 whitespace-nowrap">{message || 'Supprimer ?'}</span>
        <Button size="sm" onClick={handleConfirm}
          className="bg-red-500 text-white hover:bg-red-600 h-6 px-2 text-[10px]" data-testid="confirm-yes">
          Oui
        </Button>
        <Button size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); setOpen(false); }}
          className="text-[rgb(var(--lm-text-muted))] h-6 px-1.5" data-testid="confirm-no">
          <X size={12} />
        </Button>
      </div>
    );
  }

  return (
    <span onClick={(e) => { e.stopPropagation(); setOpen(true); }} className="cursor-pointer">
      {children}
    </span>
  );
};

export default ConfirmDelete;
